/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Config from '../../../app.config';
import PageHeading from '../../../components/PageHeading';
import SqzText from '../../../components/SqzText';
import KlaviyoPhase1List from '../../KlaviyoList/klaviyoPhase1List';
function FranchisePhase1(props) {
  const { locationServices } = props;
  let locationText = '';
  let addressText = '';
  const urlName = locationServices.url_name.toLowerCase();
  switch (urlName) {
    case 'cherrycreek':
      locationText = `OPENING EARLY 2023 IN ${locationServices.city}`;
      addressText = `in 9 + CO ${locationServices.address}`;
      break;
    case 'alamoheights':
      locationText = `OPENING SPRING 2023 IN ${locationServices.city}`;
      addressText = `on ${locationServices.address}`;
      break;
    case 'rogers':
      locationText = 'OPENING SUMMER 2023 IN NORTHWEST ARKANSAS';
      addressText = `on ${locationServices.address}`;
      break;
    case 'midtownatl':
      locationText = `OPENING FALL 2023 IN MIDTOWN ${locationServices.city}!`;
      addressText = `in Colony Square on ${locationServices.address &&
        locationServices.address.split(',')[0]}`;
      break;
    case 'buckhead':
      locationText = `OPENING FALL 2023 IN ${locationServices.name &&
        locationServices.name.split('-')[0]}`;
      addressText = `on ${locationServices.address.split(' Atlanta')[0]}`;
      break;
    case 'northbrook':
      locationText = 'OPENING EARLY 2024 IN NORTHBROOK, IL';
      addressText = 'on 31 & 35 N Skokie Blvd. Northbrook, IL 60062';
      break;
    case 'providence':
      locationText = 'OPENING 2024 IN Providence RI!';
      addressText = '129 Wayland Avenue, Providence RI 02906';
      break;
    case 'huntsville':
      locationText = 'OPENING EARLY 2024 IN Huntsville, AL';
      addressText = '1000 Mid City Drive, Suite 3C, Huntsville, AL 35806';
      break;
    case 'fortworth':
      locationText = 'OPENING 2024 IN Fort Worth!';
      addressText = `on ${locationServices.address &&
        locationServices.address.split(',')[0]}`;
      break;
    case 'sarasota':
      locationText = `OPENING 2024 IN ${locationServices.name}!`;
      addressText = 'at 3070 Fruitville Commons Blvd Suite 100';
      break;
    case 'somerville':
      locationText = `OPENING 2024 IN Somerville!`;
      addressText = `at ${locationServices && locationServices.address}`;
      break;
    case 'westport':
      locationText = `OPENING 2024 IN ${locationServices?.city}!`;
      addressText = 'at 625 Post Road E.';
      break;
    case 'sanmateo':
      locationText = `OPENING 2024 IN ${locationServices?.name}, ${
        locationServices?.state
      }!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'lagunaniguel':
      locationText = `OPENING WINTER 2024 IN ${locationServices?.city}!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'tampa':
      locationText = `OPENING 2024 IN ${locationServices?.city}, ${
        locationServices.state
      }!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'prosper':
      locationText = `OPENING 2024 IN Prosper, ${locationServices?.state}!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'westlake':
      locationText = `OPENING 2024 IN Westlake, ${locationServices?.state}!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'sanantonio':
      locationText = `OPENING 2024 IN ${locationServices?.name}, ${
        locationServices?.state
      }!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'santamonica':
      locationText = `OPENING 2025 IN ${locationServices?.name}!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'hermosabeach':
      locationText = `OPENING 2025 IN Hermosa Beach, CA!`;
      addressText = `at 703 Pier Avenue, Suite D Hermosa Beach, CA 90254`;
      break;
    case 'watertown':
      locationText = `OPENING 2024 IN ${locationServices?.name}!`;
      addressText = `at 116 Arsenal Yards Blvd`;
      break;
    case 'nashville':
      locationText = `OPENING 2025 IN ${locationServices?.name}!`;
      addressText = `810 Division Street Nashville, TN 37203`;
      break;
    case 'gilbert':
      locationText = 'OPENING 2025 IN Gilbert, Arizona!';
      addressText = `at ${locationServices?.address}`;
      break;
    case 'roseville':
      locationText = 'OPENING 2025 in Roseville, California!';
      addressText = `at ${locationServices?.address}`;
      break;
    case 'southlakeunion':
      locationText = `OPENING 2025 IN Seattle, Washington!`;
      addressText = `at ${locationServices?.address}`;
      break;
    case 'cary':
      locationText = `OPENING 2025 IN ${locationServices?.name}!`;
      addressText = `at ${locationServices?.address}`;
      break;
    default:
      break;
  }
  return (
    <Fragment>
      <section className="hero-main">
        <img
          src={`${Config.awsCloudFrontUrl}/images/phase-1/hero-new-bg.png`}
          alt="hero-bg"
          className="hide-phone hero-bg"
        />
        <img
          src={`${Config.awsCloudFrontUrl}/images/phase-1/hero-bg-m.png`}
          alt="hero-bg"
          className="phone-only"
        />
        <div className="hero-section">
          <PageHeading>{locationText}</PageHeading>
          <SqzText addClass="smallFontHowItWork ucase phone-only hiwHeader">
            {locationText}
          </SqzText>
          <h4 className="mb0 dark-grey">
            Be one of the first 100 to sign-up and
          </h4>
          <h4 className="location-text">
            {`win a free Mid Squeeze (50-min massage) at our new location ${addressText}`}
          </h4>
          <div
            className="NotifyTherapistModal"
            style={{ textAlign: 'center', background: 'none', padding: 0 }}
          >
            <KlaviyoPhase1List {...props} />
          </div>
        </div>
        <img
          src={`${Config.awsCloudFrontUrl}/images/phase-1/down-arrow.png`}
          alt="down-arrow"
          className="down-arrow"
        />
      </section>
    </Fragment>
  );
}

FranchisePhase1.propTypes = {
  locationServices: PropTypes.object,
};

export default FranchisePhase1;
